import {createApp} from 'vue'
import StylisationWithGtl from '@/components/StylisationWithGtl.vue'
import GetTheLooks from '@/components/GetTheLooks.vue'
import GetTheLooksCategorized from '@/components/GetTheLooksCategorized.vue'
import StylisationSlider from '@/components/StylisationSlider/StylisationSlider.vue'
import StylisationCollage from '@/components/StylisationCollage/StylisationCollage.vue'
import VueLazyload from "vue-lazyload";
import {createPinia} from 'pinia'
const pinia = createPinia();

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import SsrCarousel from 'vue-ssr-carousel'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

import ssrCarouselCss from 'vue-ssr-carousel/index.css'


const stylisationWithGtlApp = createApp(StylisationWithGtl)
stylisationWithGtlApp.use(VueLazyload)
stylisationWithGtlApp.use(pinia)
stylisationWithGtlApp.use(SsrCarousel)
stylisationWithGtlApp.use(ssrCarouselCss)
stylisationWithGtlApp.mount('#getTheLook')


const getTheLookApp = createApp(GetTheLooks)
getTheLookApp.use(VueLazyload)
getTheLookApp.use(pinia)
getTheLookApp.use(SsrCarousel)
getTheLookApp.use(ssrCarouselCss)
getTheLookApp.mount('#onlyGetTheLook')

const getTheLookCategorizedApp = createApp(GetTheLooksCategorized)
getTheLookCategorizedApp.use(VueLazyload)
getTheLookCategorizedApp.use(pinia)
getTheLookCategorizedApp.use(SsrCarousel)
getTheLookCategorizedApp.use(ssrCarouselCss)
getTheLookCategorizedApp.mount('#getTheLookCategorized')



const StylisationSliderApp = createApp(StylisationSlider)
StylisationSliderApp.use(VueLazyload)
StylisationSliderApp.use(pinia)
StylisationSliderApp.use(SsrCarousel)
StylisationSliderApp.use(ssrCarouselCss)
StylisationSliderApp.mount('#StylisationSlider')

const StylisationCollageApp = createApp(StylisationCollage)
StylisationCollageApp.use(VueLazyload)
StylisationCollageApp.use(pinia)
StylisationCollageApp.mount('#StylisationCollage')